export default __webpack_public_path__ + "static/3-92820c088ebf5e484c9dadec2b50036c.png";